import type { Root, Element, ElementContent } from 'hast';

import sanitizeStyle from './sanitize-style';

export default function rehypeSanitizeStyle() {
    return (tree: Root) => {
        tree.children.forEach((child) => {
            if (child.type === 'element') sanitizeElementStyle(child);
        });
    };
}

function sanitizeElementStyle(element: Element) {
    const style = element.properties?.style;

    if (typeof style === 'string') {
        const sanitizedStyle = sanitizeStyle(style);
        if (sanitizedStyle) {
            element.properties = { ...element.properties, style: sanitizedStyle };
        } else {
            delete element.properties?.style;
        }
    }

    element.children.forEach((child: ElementContent) => {
        if (child.type === 'element') sanitizeElementStyle(child);
    });
}
